import React from "react";
import "./DownloadButton.css";

const DownloadButton = () => {
  const handleDownload = () => {
    const fileUrl =
      "https://drive.google.com/file/d/1W1l8AlCDyrC8xYezvUz6mHblh8rfPgGv/view?usp=sharing/"; // Replace with the actual file name and extension
    window.open(fileUrl, "_blank");
  };

  return (
    <button className="download-button" onClick={handleDownload}>
      Download CV
    </button>
  );
};

export default DownloadButton;
